<div class="modal-header tud-modal-header">
  <h1 id="modal-title" class="modal-title no-underline">{{ title }}</h1>
  <button class="btn-close ms-auto" type="button" aria-describedby="modal-title" [attr.aria-label]="'content.close-btn' | translate" (click)="modal.dismiss('x click')"></button>
</div>
<div class="modal-body">
  <p>{{ body }}</p>
</div>
<div class="tud-modal-footer submit-buttons inline-gap-5">
  <button class="tu-button secondary tu-shadow" type="button" (click)="modal.dismiss('cancel click')">{{ 'content.cancel' | translate }}</button>
  <button class="tu-button primary tu-shadow" type="button" (click)="modal.close('ok click')">{{ 'content.yes' | translate }}</button>
</div>